module.exports = __webpack_public_path__ + "img/pg-virtualfactory.7255061f.jpg";